import { useEffect } from 'react';
import { trackViewContentEvent } from 'util/facebookAnalytics/trackingEvent';
import { IS_SSR } from 'ots-constants';

interface IProps {
  title: string,
  uuid: string,
}

export const RegionFPCTracker = ({ title, uuid } : IProps) => {
  useEffect(() => {
    if (title && !IS_SSR) {
      trackViewContentEvent(
        'regions',
        title,
        null,
        null,
        process.env.NEXT_PUBLIC_WEBSITE_DOMAIN || window.location.hostname,
      );
    }
  }, [uuid, title]);

  return null;
};
